import React, { Component } from 'react';
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import axios from "axios"
import ReactAudioPlayer from 'react-audio-player';
import 'react-html5-camera-photo/build/css/index.css';
import { HashRouter as Router, Route, Link } from "react-router-dom";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import Audios from "./Audios"

@observer
class ExpertiseEntree extends React.Component {
  loadPiece(){
    let pieceid = this.props.match.params.pieceid
    axios.post("/api/v1/experts/app/entree/dashboard/loadPiece",{id: EntreeStore.rdv.id,piece: pieceid}).then((data)=>{
      let d = data.data
      let etage = d.piece.etage ==0 ? 0 : (d.piece.etage || "")
      let entresol = d.piece.entresol==0 ? false : (d.piece.entresol || "")
      this.setState({
        piece: data.data.piece,
        etage: etage,
        numero: (d.piece.numero==undefined ? "" : d.piece.numero),
        entresol: entresol,
        expertise: data.data.expertise,
        loaded: true,
        texteInitial: data.data.text,
        done: data.data.expertise.done,
        transcription_encours: data.data.expertise.need_transcription
      })
      this.loadImages(data.data.piece,data.data.expertise)
      this.loadRecords(data.data.piece,data.data.expertise)

    })
  }
  constructor(props) {
    super(props);
    this.loadPiece = this.loadPiece.bind(this)
    this.done = this.done.bind(this)
    this.updateNumeroPiece = this.updateNumeroPiece.bind(this)
    this.savePieceData = this.savePieceData.bind(this)
    this.updateEtagePiece = this.updateEtagePiece.bind(this)
    this.loadImages = this.loadImages.bind(this)
    this.transcrire = this.transcrire.bind(this)
    this.updateEntresolPiece = this.updateEntresolPiece.bind(this)
    this.textAudioChange = this.textAudioChange.bind(this)
    this.state = {
      pieceId: this.props.match.params.pieceid,
      piece: {typedepiece: {},numero: ""},
      expertise: {},
      audios: [],
      images: [],
      numero: "",
      done: false,
      texteInitial: "",
      etage: "",
      entresol: "",
      loaded: false,
      transcription_encours: true
    };
    this.loadPiece()
  }
  componentDidUpdate(){
        var elems = document.querySelectorAll('.materialboxed');
    var instances = M.Materialbox.init(elems);
  }
  done(e){
    this.setState({
      done: e.target.value
    },()=>this.savePieceData())
  }
  loadImages(piece,expertise){
    axios.post("/api/v1/experts/app/entree/dashboard/loadImages",{id: EntreeStore.rdv.id,expertiseid: expertise.id,piece: piece.id}).then((data)=>{
      this.setState({images: data.data})
    })
  }
  loadRecords(piece,expertise){
    axios.post("/api/v1/experts/app/entree/dashboard/loadAudios",{id: EntreeStore.rdv.id,expertiseid: expertise.id,piece: piece.id}).then((data)=>{
      this.setState({audios: data.data})
    })
  }
  transcrire(){
    axios.post("/api/v1/experts/app/entree/dashboard/transcript",{id: EntreeStore.rdv.id,expertiseid: this.state.expertise.id,piece: this.state.pieceId}).then((data)=>{
      this.setState({transcription_encours: true})
      this.loadPiece()
    })
  }
  savePieceData(){
    axios.post("/api/v1/experts/app/entree/dashboard/savePieceData",{id: EntreeStore.rdv.id,
      entresol: this.state.entresol,piece: this.state.piece.id,
      numero: this.state.numero,etage: this.state.etage,
      done: this.state.done}).then((data)=>{
      console.log("done")
    })
  }
  updateNumeroPiece(e){
    this.setState({
      numero: e.target.value
    },()=>this.savePieceData())
  }
  updateEtagePiece(e){
    this.setState({
      etage: e.target.value
    },()=>this.savePieceData())
  }
    updateEntresolPiece(e){
    this.setState({
      entresol: e.target.value
    },()=>this.savePieceData())
  }
  textAudioChange(e){
    axios.post("/api/v1/experts/app/entree/dashboard/savePieceTxt",{
      id: EntreeStore.rdv.id,
      piece: this.state.piece.id,
      txt: e
    }).then((data)=>{
      console.log("sauvé")
    })
  }
  render() {
    if(EntreeStore.loaded && this.state.loaded){

      return(
        <div>
            <h1 className="center">{this.state.piece.typedepiece.titre}</h1>
            <div className="row">
              <div className="col s3">
                <h2 className="center">Info sur la pièce</h2>
                <div className="input-field">
                  <p>Numéro de pièce</p>
                  <select className="browser-default" onChange={this.updateNumeroPiece} value={this.state.numero}>
                  <option value="" disabled>Numéro de la pièce</option>
                  {[1,2,3,4,5,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map((piece)=>(
                      <option key={piece} value={piece}>{piece}</option>
                    ))}
                  </select>
                </div>
                <div className="input-field">
                  <p>Etage</p>
                  <select className="browser-default" onChange={this.updateEtagePiece} value={this.state.etage}>
                  <option value="" disabled>Numéro de la pièce</option>
                  {[-3,-2,-1,0,1,2,3,4,5].map((etage)=>(
                      <option key={etage} value={etage}>{etage}</option>
                    ))}
                  </select>
                </div>
                <div className="input-field">
                  <p>Entresol</p>
                  <select className="browser-default" onChange={this.updateEntresolPiece} value={this.state.entresol}>
                  <option value="" disabled>Non défini</option>
                  {[true,false].map((possibilite,index)=>(
                      <option key={index} value={possibilite}>{possibilite ? "Entresol" : "pas entresol"}</option>
                    ))}
                  </select>
                </div>
              <div className="input-field">
                  <p>Terminé</p>
                  <select className="browser-default" onChange={this.done} value={this.state.done}>
                  <option value="" disabled>Non défini</option>
                  {[true,false].map((possibilite,index)=>(
                      <option key={index} value={possibilite}>{possibilite ? "Terminé" : "En cours"}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={"col "+(true ? "s5" : "s3")}>
                <div className="row">
                  <Link className="btn col s3" to={"/expertise/photo/"+this.state.pieceId+"/"+this.state.expertise.id} ><i className="material-icons">add_a_photo</i></Link>
                  {this.state.transcription_encours ? (
                      <a href="" className="btn col s6 offset-s1 disabled"><i className="material-icons left">cached</i>Transcription.</a>
                    ) : (
                      <Link className="btn col s6 offset-s1 " onClick={this.transcrire} ><i className="material-icons left">edit</i>Transcrire</Link>
                    )}

                  {/*<Link className="btn col s3 offset-s1" to={"/expertise/audio/"+this.state.pieceId+"/"+this.state.expertise.id} ><i className="material-icons">record_voice_over</i></Link>*/}
                </div>
                {true ? (
                  <div>
                    <h1 className="center">Entrez ici le script de l'audio</h1>
                    <SunEditor setContents={this.state.texteInitial} onChange={this.textAudioChange}
            setOptions={
                 {
            height: 500
                  }}/>

                  </div>
                  ) : (
                    <div></div>
                  )}
              </div>
            <div className="col s4">
            <Audios match={this.props.match} expertiseid={this.state.expertise.id}/>
            </div>
            </div>
             <div className="row container">
                {this.state.images.map((img)=>(
                    <div key={img.id} className="col s3">
                      <img src={img.url} alt="" className="responsive-img materialboxed"/>
                    </div>
                  ))}
              </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}



export default ExpertiseEntree
